/* sumario dos documentos (nt-fx-doc): sempre aberto no computador, fechado no celular e marcando o trecho lido */
(function () {
  var mq = window.matchMedia('(min-width: 1024px)');

  function iniciar(raiz) {
    var det = raiz.querySelector('[data-doc-sumario]');
    if (!det || det.dataset.pronto) return;
    det.dataset.pronto = '1';
    var lista = det.querySelector('ol');
    var links = Array.prototype.slice.call(det.querySelectorAll('a[href^="#"]'));
    var alvos = links.map(function (a) { return document.getElementById(decodeURIComponent(a.hash.slice(1))); });

    function ajustar() { det.open = mq.matches; }
    ajustar();
    if (mq.addEventListener) mq.addEventListener('change', ajustar); else mq.addListener(ajustar);

    // no computador o cabecalho do sumario so rotula: nao fecha a lista
    det.querySelector('summary').addEventListener('click', function (e) { if (mq.matches) e.preventDefault(); });
    links.forEach(function (a) {
      a.addEventListener('click', function () { if (!mq.matches) det.open = false; });
    });

    var atual = -1;
    function marcar() {
      var topo = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 80;
      var lim = topo + window.innerHeight * 0.18;
      var idx = -1;
      for (var i = 0; i < alvos.length; i++) {
        if (alvos[i] && alvos[i].getBoundingClientRect().top <= lim) idx = i;
      }
      if (idx === atual) return;
      if (atual > -1) links[atual].removeAttribute('aria-current');
      atual = idx;
      if (idx < 0) return;
      var a = links[idx];
      a.setAttribute('aria-current', 'true');
      // a lista do computador rola sozinha para o item marcado ficar a vista, sem mexer na pagina
      if (mq.matches && lista.scrollHeight > lista.clientHeight) {
        var t = a.getBoundingClientRect().top - lista.getBoundingClientRect().top + lista.scrollTop - lista.clientHeight / 2 + a.offsetHeight / 2;
        lista.scrollTop = Math.max(0, t);
      }
    }
    var pedido = false;
    window.addEventListener('scroll', function () {
      if (pedido) return;
      pedido = true;
      requestAnimationFrame(function () { pedido = false; marcar(); });
    }, { passive: true });
    window.addEventListener('resize', marcar);
    marcar();
  }

  function todos() { document.querySelectorAll('[data-nt-fx="doc"]').forEach(iniciar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todos); else todos();
  document.addEventListener('shopify:section:load', todos);
})();
